<template>
  <div class="gc-status-chip-yes-no">
    <label
      v-bind:style="{
        'background-color':
          status === 'Y' ? '#62d26f' : status === 'N' ? '#e8384f' : '#e2e2e2',
      }"
      v-bind:class="{
        active: status === 'Y',
        cancelled: status === 'N',
      }"
      >{{ getFriendlyStatus(status) }}</label
    >
  </div>
</template>

<script>
export default {
  props: {
    status,
    data: {
      type: Object,
      default: () => {},
    },
  },
  methods: {
    getFriendlyStatus(status) {
      if (status === "Y") return "Yes";
      else if (status === "N") return "No";
      else return status;
    },
  },
};
</script>

<style lang="scss" scoped>
.gc-status-chip-yes-no {
  label {
    padding: 1px 5px;
    min-width: 76px;
  }

  label {
    display: block;
    color: white;
    background: #e2e2e2;
    border-radius: 8.5px;
    padding: 1px 5px;
    height: 17px !important;
    font-size: 11px;
    line-height: 1.5 !important;
    text-align: center;
  }
  .active {
    background: #62d26f;
  }

  .cancelled {
    background-color: #e8384f;
  }
}
</style>
